module.exports = __webpack_public_path__ + "assets/img/22.2b7724a2.png";